export const getInvoiceTitleListApi = (query = {}) => {
    const queryString = new URLSearchParams(query).toString();
    return `invoice_configuration`;
}
export const updateInvoiceTitleApi = (params) => {
    return `/invoice_configuration/${params}`;
};